import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const PINTEREST_INTEGRATION_NAME = 'pinterest';
export const ZPinterestIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(PINTEREST_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=pinterest.js.map